import { LucideIcon } from 'lucide-react';

export const workoutCategories = [
  {
    id: 'hiit',
    name: 'HIIT',
    icon: 'Flame',
    color: 'from-red-500 to-orange-500',
    description: 'High-intensity interval training workouts'
  },
  {
    id: 'strength',
    name: 'Strength',
    icon: 'Dumbbell',
    color: 'from-blue-500 to-indigo-500',
    description: 'Build muscle and increase strength'
  },
  {
    id: 'yoga',
    name: 'Yoga',
    icon: 'Flower2',
    color: 'from-purple-500 to-pink-500',
    description: 'Improve flexibility and mindfulness'
  },
  {
    id: 'cycling',
    name: 'Cycling',
    icon: 'Bike',
    color: 'from-green-500 to-emerald-500',
    description: 'Indoor cycling workouts'
  },
  {
    id: 'core',
    name: 'Core',
    icon: 'Target',
    color: 'from-yellow-500 to-amber-500',
    description: 'Strengthen your core muscles'
  },
  {
    id: 'dance',
    name: 'Dance',
    icon: 'Music',
    color: 'from-pink-500 to-rose-500',
    description: 'Fun cardio dance workouts'
  },
  {
    id: 'cardio',
    name: 'Cardio',
    icon: 'Heart',
    color: 'from-red-500 to-pink-500',
    description: 'Improve cardiovascular fitness'
  },
  {
    id: 'treadmill',
    name: 'Treadmill',
    icon: 'Timer',
    color: 'from-cyan-500 to-blue-500',
    description: 'Indoor running workouts'
  },
  {
    id: 'mobility',
    name: 'Mobility',
    icon: 'Move',
    color: 'from-teal-500 to-green-500',
    description: 'Improve range of motion and flexibility'
  },
  {
    id: 'boxing',
    name: 'Boxing',
    icon: 'Sword',
    color: 'from-orange-500 to-red-500',
    description: 'High-energy boxing workouts'
  },
  {
    id: 'recovery',
    name: 'Recovery',
    icon: 'Battery',
    color: 'from-blue-500 to-purple-500',
    description: 'Active recovery and regeneration'
  },
  {
    id: 'meditation',
    name: 'Meditation',
    icon: 'Brain',
    color: 'from-purple-500 to-indigo-500',
    description: 'Mental wellness and mindfulness'
  }
];

export const workouts = [
  // HIIT Workouts
  {
    id: 'hiit-1',
    name: 'Glory Elite HIIT',
    level: 'Elite',
    duration: 90,
    strain: 16.5,
    targetStrain: 16.5,
    targetMuscles: ['Full Body'],
    image: 'https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=800&q=80',
    coach: {
      name: 'Chris Glory',
      image: 'https://images.unsplash.com/photo-1563351672-62b74891a28a?w=400&h=400&fit=crop&q=80',
      specialties: ['HIIT', 'Elite Performance', 'Strength & Conditioning']
    },
    category: 'hiit',
    isElite: true,
    description: 'An intense full-body workout designed for elite athletes',
    type: 'HIIT',
    exercises: [
      {
        name: 'Warm Up',
        duration: 300,
        intensity: 'Light',
        description: 'Dynamic stretching and mobility work'
      },
      {
        name: 'Circuit 1',
        duration: 900,
        intensity: 'High',
        description: 'Burpees, Mountain Climbers, Box Jumps'
      },
      {
        name: 'Active Recovery',
        duration: 180,
        intensity: 'Light',
        description: 'Light jogging and mobility'
      },
      {
        name: 'Circuit 2',
        duration: 900,
        intensity: 'High',
        description: 'Kettlebell Swings, Battle Ropes, Sprints'
      },
      {
        name: 'Cool Down',
        duration: 300,
        intensity: 'Light',
        description: 'Static stretching and breathing'
      }
    ]
  },
  {
    id: 'hiit-2',
    name: 'Tabata Inferno',
    level: 'Advanced',
    duration: 45,
    strain: 14.2,
    targetStrain: 14.2,
    targetMuscles: ['Full Body'],
    image: 'https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=800&q=80',
    coach: {
      name: 'Alex Rivers',
      image: 'https://images.unsplash.com/photo-1548372290-8d01b6c8e78c?w=400&h=400&fit=crop&q=80',
      specialties: ['HIIT', 'Tabata', 'Metabolic Conditioning']
    },
    category: 'hiit',
    type: 'HIIT',
    description: 'High-intensity Tabata intervals for maximum calorie burn'
  },

  // Strength Workouts
  {
    id: 'strength-1',
    name: 'Total Body Strength',
    level: 'Intermediate',
    duration: 45,
    strain: 12.5,
    targetStrain: 12.5,
    targetMuscles: ['Full Body'],
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80',
    coach: {
      name: 'Sarah Chen',
      image: 'https://images.unsplash.com/photo-1548372290-8d01b6c8e78c?w=400&h=400&fit=crop&q=80',
      specialties: ['Strength Training', 'Olympic Lifting', 'Powerlifting']
    },
    category: 'strength',
    type: 'Strength',
    description: 'Build strength and muscle with this comprehensive workout',
    exercises: [
      {
        name: 'Warm Up',
        duration: 300,
        intensity: 'Light',
        description: 'Joint mobility and activation'
      },
      {
        name: 'Strength Block 1',
        duration: 900,
        intensity: 'Moderate',
        description: 'Squats, Deadlifts, Bench Press'
      },
      {
        name: 'Core Work',
        duration: 300,
        intensity: 'Moderate',
        description: 'Planks and anti-rotation work'
      },
      {
        name: 'Cool Down',
        duration: 300,
        intensity: 'Light',
        description: 'Static stretching'
      }
    ]
  },
  {
    id: 'strength-2',
    name: 'Power Building',
    level: 'Advanced',
    duration: 60,
    strain: 13.8,
    targetStrain: 13.8,
    targetMuscles: ['Full Body'],
    image: 'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=800&q=80',
    coach: {
      name: 'Mike Strong',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&q=80',
      specialties: ['Powerlifting', 'Strength Training', 'Hypertrophy']
    },
    category: 'strength',
    type: 'Strength',
    description: 'Focus on compound lifts and progressive overload'
  },

  // Yoga Workouts
  {
    id: 'yoga-1',
    name: 'Power Vinyasa Flow',
    level: 'Intermediate',
    duration: 60,
    strain: 8.5,
    targetStrain: 8.5,
    targetMuscles: ['Full Body'],
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80',
    coach: {
      name: 'Maya Patel',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&q=80',
      specialties: ['Yoga', 'Meditation', 'Mobility']
    },
    category: 'yoga',
    type: 'Yoga',
    description: 'Dynamic yoga flow combining strength and flexibility'
  },

  // Cycling Workouts
  {
    id: 'cycling-1',
    name: 'Power Zone Endurance',
    level: 'Intermediate',
    duration: 45,
    strain: 11.2,
    targetStrain: 11.2,
    targetMuscles: ['Lower Body'],
    image: 'https://images.unsplash.com/photo-1534787238916-9ba6764efd4f?w=800&q=80',
    coach: {
      name: 'Tom Rider',
      image: 'https://images.unsplash.com/photo-1600486913747-55e5470d6f40?w=400&h=400&fit=crop&q=80',
      specialties: ['Cycling', 'Endurance', 'Power Training']
    },
    category: 'cycling',
    type: 'Cycling',
    description: 'Build endurance with power zone training'
  },

  // Core Workouts
  {
    id: 'core-1',
    name: 'Core Crusher',
    level: 'Intermediate',
    duration: 30,
    strain: 9.5,
    targetStrain: 9.5,
    targetMuscles: ['Core'],
    image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80',
    coach: {
      name: 'Lisa Chen',
      image: 'https://images.unsplash.com/photo-1499952127939-9bbf5af6c51c?w=400&h=400&fit=crop&q=80',
      specialties: ['Core Training', 'Pilates', 'Functional Movement']
    },
    category: 'core',
    type: 'Core',
    description: 'Intense core workout focusing on all abdominal muscles'
  }
];